<template>
  <div class="register-tab">
    <SalesRegisterToolbar
        ref="toolbarRef"
        :filters="appliedFilters"
        :chip-meta="filterChipMeta"
        popover-width="400px"
        @go="onClickGo"
        @open-filter="onOpenFilter"
        @apply="onApplyFilters"
        @clear="onClearFilters"
        @remove-chip="onRemoveChip"
        @print="onClickToPrint"
        @export="exportTable"
    >
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between">
          <label class="filter-label">Supplier</label>
          <span class="filter-search-icon" @click="onOpenContactSearchModal">
            <i class="fas fa-search"></i>
          </span>
        </div>
        <AsyncSelect
            placeholder="Supplier Name, ID, Mobile No"
            v-model="draftFilters.supplier"
            :api-service="fetchContactProfiles"
            :additional-query="supplierQueryObj"
            :format-label="formatPatientLabel"
        />
      </div>
      <div class="col-12">
        <label class="filter-label">Business Unit</label>
        <v-select
            placeholder="Select Business Unit"
            v-model="draftFilters.business_unit"
            :options="businessList"
            label="name"
        />
      </div>
    </SalesRegisterToolbar>
    <RegisterTable
        tab="supplier"
        :rows="rows"
        :current-page="pageData.current_page"
        :last-page="pageData.last_page"
        :per-page="pageData.per_page"
        :total-value="registerData.total"
        :is-loaded="hasLoaded"
    />
    <div class="mt-2">
      <Pagination :offset="offset" @onPageChange="onPageChange"/>
    </div>
    <ContactDropdownFilter
        v-if="$store.state.isModalOpenThree"
        @onSearchContact="onSearchContact"
        type="supplier"
    />
    <Loader v-if="loading"/>
  </div>
</template>

<script setup>
import Pagination from '@/components/atom/Pagination'
import Loader from '@/components/atom/LoaderComponent.vue'
import ContactDropdownFilter from '@/components/atom/Contact/ContactDropdownFilter.vue'
import SalesRegisterToolbar from '@/components/molecule/company/inventory/product-sales-register/SalesRegisterToolbar.vue'
import RegisterTable from '@/components/molecule/company/inventory/purchase-register/RegisterTable.vue'
import AsyncSelect from '@/components/molecule/input-field/AsyncSelect.vue'
import handleContact from '@/services/modules/contact'
import { useAsyncDropdownHelper } from '@/services/utils/asyncDropdownHelper'
import usePurchaseRegisterTab from '@/composables/usePurchaseRegisterTab'

defineProps({
  businessList: {
    type: Array,
    default: () => []
  }
})

const { fetchContactProfiles } = handleContact()
const { formatPatientLabel } = useAsyncDropdownHelper()

const supplierQueryObj = { roles: 'supplier' }

const filterChipMeta = [
  { key: 'supplier', label: 'Supplier', text_key: 'name' },
  { key: 'business_unit', label: 'Business Unit', text_key: 'name' }
]

const getEmptyFilters = () => {
  return {
    supplier: null,
    business_unit: null
  }
}

const getFilterQuery = (filters) => {
  let query = ''
  if (filters.supplier) query += '&contact_profile_id=' + filters.supplier.id
  if (filters.business_unit) query += '&business_id=' + filters.business_unit.id
  return query
}

const {
  offset,
  loading,
  hasLoaded,
  rows,
  registerData,
  pageData,
  toolbarRef,
  appliedFilters,
  draftFilters,
  onClickGo,
  onPageChange,
  onOpenFilter,
  onApplyFilters,
  onClearFilters,
  onRemoveChip,
  onOpenContactSearchModal,
  onSearchContact,
  onClickToPrint,
  exportTable
} = usePurchaseRegisterTab('supplier', getEmptyFilters, getFilterQuery)
</script>
